import { QUESTION } from '@constants/terminology';

export enum SubmitVerifiedButtonState {
  Show,
  Enable,
}

export enum SubmitDisabledReasonType {
  MandatoryFieldEmpty = 'mandatoryFieldEmpty',
  UnitMismatch = 'unitMismatch',
  NumberScaleMismatch = 'numberScaleMismatch',
  DecimalError = 'decimalError',
}

export interface SubmitDisabledReason {
  type: SubmitDisabledReasonType;
  message?: string;
}

export const QuestionButtonTooltip = {
  NothingToSubmit: 'Nothing to submit',
  NothingToSubmitOrVerify: 'Nothing to submit or verify',
  MandatoryFieldsRequired: 'You must enter data into the mandatory fields (marked with *).',
  UnitMismatch: 'Please correct the unit to match the required value.',
  NumberScaleMismatch: 'Please correct the number scale to match the required value.',
  DecimalError: 'Please correct the decimal format to meet the required precision.',
  UpdateToSubmit: 'Update answer to submit',
  SubmitWithoutVerification: 'Submit answer without verification',
  SubmitAsVerification: 'Submit answer and mark it as verified',
  NoteRequiredOnRestatement: 'You cannot submit until you provide an explanation/note about the restatement',
  UnableToSubmit: `Unable to submit once ${QUESTION.SINGULAR} has been verified. Contact your verifier if you believe the submission to be incorrect`,
  NothingToVerify: 'Nothing to verify',
};

const DefaultSubmitDisabledReasonTooltip: Record<SubmitDisabledReasonType, string> = {
  [SubmitDisabledReasonType.MandatoryFieldEmpty]: QuestionButtonTooltip.MandatoryFieldsRequired,
  [SubmitDisabledReasonType.UnitMismatch]: QuestionButtonTooltip.UnitMismatch,
  [SubmitDisabledReasonType.NumberScaleMismatch]: QuestionButtonTooltip.NumberScaleMismatch,
  [SubmitDisabledReasonType.DecimalError]: QuestionButtonTooltip.DecimalError,
};

export const getSubmitDisabledReasonTooltip = (reasons: SubmitDisabledReason[]): string => {
  if (reasons.length === 0) {
    return '';
  }
  const first = reasons[0];
  return first.message || DefaultSubmitDisabledReasonTooltip[first.type] || '';
};

export enum OmissionReason {
  NA = 'na',
  NRProhibitions = 'nrProhibitions',
  NRConstraints = 'nrConstraints',
  NRUnavailable = 'nrUnavailable',
}
